import { visuallyHidden } from '@mui/utils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ChkGenericLoader, ChkHeader } from '@ui/checkout-components';

import { useErrorContext } from '../../contexts/error/errorContext';
import { SCA_EVENTS } from '../../models/globals/events.constants';
import { useScaSubject } from '../../providers/ScaSubjectProvider/ScaSubjectProvider.hooks';
import { dataLayer } from '../../utils/dataLayer';
import { TRANSLATION_KEYS } from '../../utils/TranslationKeys';

export function WaitingForVerificationStatusView() {
  const { t } = useTranslation();
  const { error } = useScaSubject();
  const { setError } = useErrorContext();

  useEffect(() => {
    dataLayer.trackEvent({ name: SCA_EVENTS.REDIRECT_LOADER });
  }, []);

  useEffect(() => {
    if (!error) {
      return;
    }

    setError(error);
    dataLayer.trackEvent({
      name: SCA_EVENTS.REDIRECT_LOADER_ERROR,
      properties: {
        code: error.message,
      },
    });
  }, [error, setError]);

  return (
    <main>
      <ChkHeader style={visuallyHidden}>
        {t(TRANSLATION_KEYS.WAITING_FOR_VERIFY_STATUS)}
      </ChkHeader>
      <ChkGenericLoader />
    </main>
  );
}
